import { ChatModel } from '@/models/chat.model'
import { put } from 'redux-saga/effects'
import { resumeChatAction } from '../../actions'
import { update } from '../_http/chat'

export function* resumeChatSaga(action: ReturnType<typeof resumeChatAction.request>) {
  const { activeChat, currentOperatorId } = action.payload
  try {
    updateChatDurationsOnResume(activeChat, currentOperatorId)
    const updatedData: Partial<ChatModel> = {
      durations: activeChat?.durations,
      isPaused: false
    }
    yield update(activeChat.id, { ...updatedData, updatedAt: new Date().getTime() })
    yield put(resumeChatAction.success({ updatedChatData: updatedData }))
  } catch (error) {
    console.error('Error when starting chat:', error)
    yield put(resumeChatAction.failure(error))
  }
}

function updateChatDurationsOnResume(activeChat: ChatModel, operatorId: string) {
  const operatorDuration = findOperatorDuration(activeChat, operatorId)
  if (operatorDuration?.operatorId) {
    operatorDuration.periods.push({ startTime: Date.now() })
  } else {
    activeChat.durations = activeChat.durations ?? []
    activeChat.durations.push({ operatorId, periods: [{ startTime: Date.now() }] })
  }
}

function findOperatorDuration(activeChat: ChatModel, operatorId: string) {
  const durations = activeChat?.durations ?? []
  const operatorDuration = durations.find(duration => duration.operatorId === operatorId)
  return operatorDuration
}
